import Login from './Login.mapper';

export default {
  name: 'Login',
  location: '/login',
  component: Login,
};
